import createI18n from '@/locale/index';
import { useConversationsStore } from '@/stores/conversations/conversations.store';
import { type ConversationType, type MessageType, MessageContentTypes } from '@/types/conversation.types';

type MessageWithLogType = MessageType & {
  logMessage?: MessageType;
};

export default function newMessage(data: MessageWithLogType): void {
  const conversationsStore = useConversationsStore();
  const { t } = createI18n.global;

  let lastMessage: string = '';

  switch (data.content.messageType) {
    case MessageContentTypes.TEXT:
    case MessageContentTypes.LINK:
      lastMessage = data.content.value as string;
      break;

    case MessageContentTypes.WHATSAPP_TEMPLATE:
    case MessageContentTypes.TEMPLATE:
      lastMessage = `📎 ${data.content.messageType}`;
      break;

    case MessageContentTypes.ORDER:
      lastMessage = `🛒 ${data.content.messageType}`;
      break;

    case MessageContentTypes.AUDIO:
      lastMessage = `🎵 ${data.content.messageType}`;
      break;

    case MessageContentTypes.IMAGE:
      lastMessage = `🖼️ ${data.content.messageType}`;
      break;

    case MessageContentTypes.VIDEO:
      lastMessage = `🎥 ${data.content.messageType}`;
      break;

    case MessageContentTypes.DOCUMENT:
      lastMessage = `📄 ${data.content.messageType}`;
      break;

    case MessageContentTypes.CONTACTS:
      lastMessage = `👤 ${data.content.contactData && data.content.contactData?.length > 1 ? t('conversations.messages.contact.contacts-shared-title_trans') : t('conversations.messages.contact.contact-shared-title_trans')}`;
      break;

    case MessageContentTypes.LOCATION:
      lastMessage = `📍 ${t('conversations.messages.location.title_trans')}`;
      break;

    case MessageContentTypes.SHARE_POST:
      lastMessage = `📱 ${t('conversations.messages.tiktok_post_trans')}`;
      break;

    case MessageContentTypes.INTERACTIVE:
      lastMessage = `⚡ ${data.content.messageType}`;
      break;

    // case MessageContentTypes.AD:
    //   lastMessage = `📢 ${data.content.messageType}`;
    //   break;

    case MessageContentTypes.LOGS:
      lastMessage = `📜 ${data.content.value}`;
      break;

    case MessageContentTypes.CSAT:
      lastMessage = `⭐ ${data.content.messageType}`;
      break;

    default:
      lastMessage = data.conversationData?.lastMessage || t('conversations.messages.unsupported_message_type_trans');
  }

  if (data.content.isFailed) {
    lastMessage += `⚠️ ${t('conversations.messages.failed_to_process_trans')}`;
  }

  conversationsStore.updateOrInsertConversation({
    ...data.conversationData!,
    lastMessage,
  });

  if ((conversationsStore.activeConversation as ConversationType)?.conversationId === data.conversationId) {
    conversationsStore.updateActiveConversation(data.conversationData!);
    conversationsStore.updateOrInsertMessage(data);

    if (data.logMessage) {
      conversationsStore.addNewMessage(data.logMessage);
    }
  }
  conversationsStore.addNewCacheMessage(data);
  if (data.logMessage) {
    conversationsStore.addNewCacheMessage(data.logMessage);
  }
}
